import { Button, Div, Text } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Step } from './styles'
import StepText from './Text'
import { capitalize } from 'utils/common'

import ImgWrapper from './ImgWrapper'
import ImgStep1 from './ImgStep1'
import ImgStep2 from './ImgStep2'
import ImgStep3 from './ImgStep3'
import ImgStep1Resp from './ImgStep1Resp'
import ImgStep2Resp from './ImgStep2Resp'
import ImgStep3Resp from './ImgStep3Resp'

const Steps = () => {

  const { t } = useTranslation()
  const { isMobile, isTab } = useResponsive()

  const Img1 = isMobile ? ImgStep1Resp : ImgStep1
  const Img2 = isMobile ? ImgStep2Resp : ImgStep2
  const Img3 = isMobile ? ImgStep3Resp : ImgStep3

  return (
    <Div marginTop={isMobile ? 64 : 120}>

      <Div>
        <Text size={isMobile ? '2xl' : '4xl'} color='headline' align='center'>
          {t('flixxoWelcomesYou')}
        </Text>

        <Div
          width='90%'
          maxWidth={572}
          margin={isMobile ? '24px auto 40px' : '24px auto 72px'}
        >
          <Text size={isMobile ? 'sm' : 'base'} align='center'>
            {t('firstWeHugYou')}
          </Text>
        </Div>
      </Div>

      <Step>
        <Div justifySelf='center' gridArea='line'
          display='flex'
          flexDirection='column'
          gap={4}
          alignItems='center'
          marginBottom={isTab ? 24 : 4}
        >
          <Div
            height={80}
            width={1}
            background='linear-gradient(180deg, rgba(127, 57, 250, 0.1) 0%, #D9D9D9 100%)'
          />
          <Div
            height={8}
            width={8}
            borderRadius={100}
            backgroundColor='#D9D9D9'
          />
        </Div>
      </Step>


      <Step>
        <ImgWrapper>
          <Img1
            width='100%'
            height='100%'
            creator={t('creator')}
            creatorTime={t('timeAgo', { number: 20, unit: 'min.' })}
            creatorText={t('creatorTextChat')}
            flixxoTime={t('timeAgo', { number: 1, unit: 'min.' })}
            flixxoText={t('flixxoTextChat')}
          />
        </ImgWrapper>

        <Div justifySelf='center' gridArea='line'
          display='flex'
          flexDirection='column'
          gap={4}
          alignItems='center'
          marginBottom={isTab ? 24 : 4}
        >
          <Div
            height={isTab ? 82 : '100%'}
            width={1}
            backgroundImage={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D9D9D9' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`}
          />
          <Div
            height={8}
            width={8}
            borderRadius={100}
            backgroundColor='#D9D9D9'
          />
        </Div>

        <StepText
          number={1}
          title={t('reachOutToUs')}
          description={t('showUsYourMicroseries')}
        />
      </Step>


      <Step>
        {/* <Img src={isTab ? TextCard2RespImg : TextCard2Img} /> */}
        <ImgWrapper>
          <Img2
            width='100%'
            height='100%'
            yourContent={t('yourContent')}
          />
        </ImgWrapper>

        <Div justifySelf='center' gridArea='line'
          display='flex'
          flexDirection='column'
          gap={4}
          alignItems='center'
          marginBottom={isTab ? 24 : 4}
        >
          <Div
            height={isTab ? 82 : '100%'}
            width={1}
            backgroundImage={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D9D9D9' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`}
          />
          <Div
            height={8}
            width={8}
            borderRadius={100}
            backgroundColor='#D9D9D9'
          />
        </Div>

        <StepText
          number={2}
          title={t('addYourMicroseries')}
          description={t('workTogetherToPublish')}
        />
      </Step>


      <Step>
        <ImgWrapper>
          <Img3
            width='100%'
            height='100%'
            yourContent={t('yourContent')}
            watchSE={t('watchSE', { season: 1, episode: 1 })}
            episodes={capitalize(t('episodes'))}
          />
        </ImgWrapper>

        <Div
          height={isTab ? 92 : '100%'}
          width={1}
          gridArea='line'
          justifySelf='center'
          background='linear-gradient(180deg, rgba(127, 57, 250, 0.1) 0%, #7F39FA 100%)'
        />

        <StepText
          number={3}
          title={t('monetizeEachView')}
          description={t('earnFlixxWithNoIntermediaries')}
        />
      </Step>

      <Div width='90%' margin='0 auto' marginTop={24}>
        <Text size='sm' weight='medium' color='highlight' align='center'>
          <Div
            as='span'
            background='linear-gradient(90deg, #B224EF 0%, #7F39FA 100%)'
            WebkitBackgroundClip='text'
            WebkitTextFillColor='transparent'
          >
            {t('beProtagonist')}
          </Div>
        </Text>
        <Div marginTop={12} marginBottom={24}>
          <Text size={isMobile ? 'xl' : '3xl'} color='headline' align='center'>
            {t('becomeCreator')}
          </Text>
        </Div>
        <Div display='grid' placeItems='center'>
          <Button
            openNewTab
            to={{ pathname: 'mailto:content@flixxo.com' }}
            size={isMobile ? 'small' : 'large'}
          >
            {t('beCreator')}
          </Button>
        </Div>
      </Div>
    </Div>
  )
}

export default Steps